import angular from 'angular';

class ToArrayFilter {

    static factory() {
        'ngInject';
        return new ToArrayFilter();
    }
    
    filter(obj, addKey) {
        if (!angular.isObject(obj)) return obj;
        if (addKey === false) {
            return Object.keys(obj).map(function (key) {
                return obj[key];
            });
        } else {
            return Object.keys(obj).map(function (key) {
                const value = obj[key];
                return angular.isObject(value) ?
                    Object.defineProperty(value, '$key', { enumerable: false, value: key }) :
                    { $key: key, $value: value };
            });
        }
    }
}

// Explicit DI annotation for factory used by angular.filter registration
ToArrayFilter.factory.$inject = [];

export default ToArrayFilter.factory;
